import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilder.vue?vue&type=template&id=16941d5e&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilder.vue?vue&type=style&index=0&id=16941d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16941d5e",
  null
  
)

export default component.exports